import React from "react";
import { useNavigate } from "react-router-dom";

const SupportCard = () => {
  const navigate = useNavigate();
  return (
    <div className="support-card">
      <p className="fs-10 text-center fw-500">
        سوالی دارید؟ پشتیبانان ما آماده
        <br />
        پاسخگویی هستند
      </p>
      <button
        className="fs-10 fw-500 mt-3"
        onClick={() => {
          navigate("/support");
        }}
      >
        ارتباط با پشتیبان
      </button>
    </div>
  );
};

export default SupportCard;
